import objectPath from 'object-path'
import _ from 'lodash'

const COMMONS = {
	install (Vue, options) {
		Vue.prototype.$commons = {

			deepGet (obj, deep_path, default_value = '') {
				return objectPath.get(obj, deep_path, default_value)
			},

			deepSet (obj, deep_path, value) {
				objectPath.set(obj, deep_path, value)
				return value
			},

			arrayToObject (array, key) {
				try {
					return array.reduce((obj, item, index) => {
						obj[item[key]] = { ...item, index: index }
						return obj
					}, {})
				} catch (error) {
					return {}
				}
			},

			isEmptyObject (obj) {
				let entries = Object.entries(obj).filter(([k, v], i) => v === 0 || !!v)
				if (entries.length > 0) {
					return false
				}
				return true
			},

			isEmptyKey (value) {
				return (value == null || value.length === 0)
			},

			objectDiffer (object, base) {
				function changes (object, base) {
					return _.transform(object, function (result, value, key) {
						if (!_.isEqual(value, base[key])) {
							result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value
						}
					})
				}
				let dif = changes(object, base)
				return (Object.keys(dif).length > 0) ? dif : false
			},

			uuid () {
				var dt = new Date().getTime()
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (dt + Math.random() * 16) % 16 | 0
					dt = Math.floor(dt / 16)
					return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
				})
				return uuid
			},

			roundTo (num, round) {
				return +(Math.round(num + `e+${round}`) + `e-${round}`)
			},

			removeDupInArr (arr) {
				let uniqueArray = arr.filter((item, pos) => {
					return arr.indexOf(item) === pos
				})
				return uniqueArray
			},

			copyObject (obj) {
				try {
					return JSON.parse(JSON.stringify(obj))
				} catch (e) {
					console.error(`Error Utils copyObject`, e)
					return false
				}
			},

			isString (obj) {
				return (Object.prototype.toString.call(obj) === '[object String]')
			},

			isObject (object) {
				return object instanceof Object
			},

			objectSort (obj) {
				let ordered = {}
				Object.keys(obj).sort().map(key => {
					ordered[key] = obj[key]
				})
				return ordered
			},

			checkarrayObjDuplications (array, keysToIgnore) {
				const itemsStr = JSON.parse(JSON.stringify(array)).map(item => {
					for (var i in keysToIgnore) {
						delete item[keysToIgnore[i]]
					}
					let itemArr = []
					Object.keys(item).sort().map(key => {
						itemArr.push(`${key}:${item[key]}`)
					})
					return itemArr.join('|')
				})
				return itemsStr.some(function (item, idx) {
					return itemsStr.indexOf(item) !== idx
				})
			},

			range (start, end) {
				return Array.from(Array(end - start).keys()).map(v => start + v)
			},

			promiseTimeout (ms, promise) {
				// Create a promise that rejects in <ms> milliseconds
				let timeout = new Promise((resolve, reject) => {
					let id = setTimeout(() => {
						clearTimeout(id)
						reject(new Error('Timed out in ' + ms + 'ms.'))
					}, ms)
				})
				return Promise.race([
					promise,
					timeout
				])
			},

			async PromiseSeq (promiseArr) {
				let data = []
				for (var prom of promiseArr) {
					await prom
						.then(result => {
							data.push(result)
						})
						.catch(error => {
							throw error
						})
				}
				return data
			},

			dynamicSort (property) {
				var sortOrder = 1
				if (property[0] === '-') {
					sortOrder = -1
					property = property.substr(1)
				}
				return function (a, b) {
					var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
					return result * sortOrder
				}
			},

			getObjectValues (data) {
				let output = []
				for (var property in data) {
					if (data.hasOwnProperty(property)) {
						if (typeof data[property] === 'object') {
							let nesteds = this.getObjectValues(data[property])
							nesteds.map(nested => {
								output.push(nested)
							})
						} else {
							if (typeof data[property] === 'string') {
								output.push(data[property].toLowerCase())
							} else {
								output.push(data[property])
							}
						}
					}
				}
				return output
			},

			checkResponse (response) {
				if (response.status >= 200 && response.status < 300) {
					return true
				} else {
					return false
				}
			}

		}
	}
}

export default COMMONS



// WEBPACK FOOTER //
// ./src/plugins/commons.js